import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer-premium">
      <div className="footer-container">
        
        {/* Brand Column */}
        <div className="footer-brand">
          <h2>
            <span className="brand-text">Sunraf InfoTech</span>
          </h2>
          <p>
            Pioneering "Smart QR" healthcare ecosystems. We bridge the gap between 
            medical expertise and digital efficiency.
          </p>
        </div>

        {/* Company Links */}
        <div className="footer-links">
          <h3>Company</h3>
          <ul>
            <li><Link to="/">Home</Link></li>
            <li><Link to="/services">Services</Link></li>
            <li><Link to="/contact">Contact</Link></li>
          </ul>
        </div>

        {/* Solutions Links */}
        <div className="footer-links">
          <h3>Solutions</h3>
          <ul>
            <li><Link to="/services">Hospital Management</Link></li>
            <li><Link to="/services">Doctor Portals</Link></li>
            <li><Link to="/services">Smart QR Flow</Link></li>
            <li><Link to="/industries">Pharmacy Hub</Link></li>
          </ul>
        </div>

        {/* Contact Info */}
        <div className="footer-links">
          <h3>Get in Touch</h3>
          <div className="contact-item">
            <i>✉</i>
            <span>info@sunrafinfotech.com</span>
          </div>
          <div className="contact-item">
            <i>📞</i>
            <span>+91 7993325373</span>
          </div>
          <div className="contact-item">
            <i>📍</i>
            <span>HealthTech Hub, India</span>
          </div>
        </div>

      </div>

      {/* Copyright Bar */}
      <div className="footer-bottom">
        <p>&copy; {currentYear} Sunraf InfoTech. All rights reserved.</p>
        <div className="footer-legal">
          <Link to="/">Privacy Policy</Link>
          <Link to="/">Terms of Service</Link>
        </div>
      </div>
    </footer>
  );
};

export default Footer;